import { h } from 'preact'
import Panel from '../panel'
import RadioInputGroup from '../ui-components/RadioInputGroup'

interface Props {
  currentType: number,
  onUpdate: (option: string, value: number) => void
}
const visibilityOptions = [
  'Public group', 
  'Private group'
]
const typeMap: {
  [key: number]: string
} = {
  4: 'Public group',
  5: 'Private group'
}

const valueDescriptions: {
  [key: number]: string
} = {
  0: 'Anyone can join a group, after joining a group a user can post topics and comments. Group members and content are always visible.',
  1: 'Users have to be approved by a group admin to join a group, after approval a user can post topics and comments. Group members and content are not visible until a user has joined a group.'
}

const valueMap: {
  [key: number]: number
} = {
  0: 4,
  1: 5
}

const GroupVisibilityPanel = ({ currentType, onUpdate }: Props) => (
  <Panel title='Settings'>
    <div className='form-group group-visibility-type'>
      <RadioInputGroup
        title={'Group visibility'}
        name='group-visibility'
        options={visibilityOptions}
        onChange={(option: string, value: number) => { onUpdate(option, valueMap[value]) }}
        value={typeMap[currentType] || visibilityOptions[0]}
        valueDescriptions={valueDescriptions}
      />
    </div>
  </Panel>
)

export default GroupVisibilityPanel
